import Swiper from "swiper/bundle";

global.$ = jQuery;

global._isSP = undefined;

if (window.outerWidth < 829) {
  _isSP = true;
} else {
  _isSP = false;
}

var Init = function () {
  var $window = $(window);
  var $html = $("html");
  var $body = $("body");
  var windowInnerHeight = window.innerHeight;

  // MODAL（対象外店舗一覧）。開いたら閉じるボタンへフォーカス、閉じたら開いたボタンへ戻す
  var modal = document.getElementById("store-modal");
  var modalOpener = null;

  if (modal) {
    var $modal = $(modal);

    var OpenModal = function (e) {
      modalOpener = e.currentTarget;
      $(e.currentTarget).attr("aria-expanded", "true");
      modal.hidden = false;
      $html.addClass("is-modal");
      var _t = setTimeout(function () {
        $modal.addClass("is-open");
        $modal.find(".modal--close").trigger("focus");
        clearTimeout(_t);
      }, 20);
    };

    var CloseModal = function () {
      $(".modal--btn").attr("aria-expanded", "false");
      $modal.removeClass("is-open");
      var _t = setTimeout(function () {
        modal.hidden = true;
        $html.removeClass("is-modal");
        if (modalOpener) {
          modalOpener.focus();
          modalOpener = null;
        }
        clearTimeout(_t);
      }, 300);
    };

    $body.on("click", ".modal--btn", OpenModal);
    $modal.on("click", ".modal--close", CloseModal);
    $modal.on("click", ".modal-overlay", CloseModal);
    // 縦中央寄せラッパーの余白部分（ボックス外）クリックでも閉じる
    $modal.on("click", ".modal-content", function (e) {
      if (e.target === e.currentTarget) CloseModal();
    });
    $(document).on("keydown", function (e) {
      if (e.which === 27 && $html.hasClass("is-modal")) CloseModal();
    });
  }

  // ANCHOR
  $(".anchor").on("click", function () {
    var _$this = $(this);
    var href = _$this.attr("href");
    var _$target = $(href);

    $("html, body").stop().animate({scrollTop: _$target.offset().top}, 1000, "swing");

    return false;
  });

  // RESIZE
  var Resize = function () {
    windowInnerHeight = window.innerHeight;

    if ($window.width() < 829) {
      if (!_isSP) _isSP = true;
    } else {
      if (_isSP) _isSP = false;
    }
  };
  $window.on("resize", Resize);
  Resize();

  // 館内装飾は静止画1枚（修正指示2026-08-17 スライド2: スライダー・矢印を廃止）

  // PC スクロールインジケーター（スクロール追従＋つまみとしてドラッグでページスクロール操作）
  var scrollBall = document.querySelector(".pc_r--scroll");
  var scrollTrack = document.querySelector(".pc_r--scrollbar");

  if (scrollBall && scrollTrack) {
    var GetMaxScroll = function () {
      return document.documentElement.scrollHeight - window.innerHeight;
    };

    var GetTravel = function () {
      return scrollTrack.offsetHeight - scrollBall.offsetHeight;
    };

    var UpdateScrollBall = function () {
      if (_isSP) return;
      var max = GetMaxScroll();
      var progress = max > 0 ? Math.min(1, Math.max(0, window.pageYOffset / max)) : 0;
      scrollBall.style.transform = "translateY(" + (progress * GetTravel()) + "px)";
    };

    $window.on("scroll resize", UpdateScrollBall);
    UpdateScrollBall();

    // ドラッグ操作（pointer capture でボール外に出ても追従）
    var dragStartY = null;
    var dragStartScroll = 0;

    scrollBall.addEventListener("pointerdown", function (e) {
      if (_isSP) return;
      dragStartY = e.clientY;
      dragStartScroll = window.pageYOffset;
      try {
        scrollBall.setPointerCapture(e.pointerId);
      } catch (err) { /* 合成イベント等で pointerId が無効な場合は無視 */ }
      scrollBall.classList.add("is-dragging");
      e.preventDefault(); // 画像のネイティブドラッグを抑止
    });

    scrollBall.addEventListener("pointermove", function (e) {
      if (dragStartY === null) return;
      // pointerupを取りこぼしてもボタンが離れていたら即キャンセル（キャプチャ失敗時のスタック対策）
      if (e.buttons === 0) {
        EndBallDrag();
        return;
      }
      var travel = GetTravel();
      if (travel <= 0) return;
      var ratio = GetMaxScroll() / travel; // つまみ1pxあたりのスクロール量
      window.scrollTo(0, dragStartScroll + (e.clientY - dragStartY) * ratio);
    });

    var EndBallDrag = function () {
      if (dragStartY === null) return;
      dragStartY = null;
      scrollBall.classList.remove("is-dragging");
    };
    scrollBall.addEventListener("pointerup", EndBallDrag);
    scrollBall.addEventListener("pointercancel", EndBallDrag);
    // キャプチャ喪失（要素差し替え・ブラウザ都合）やドラッグ中のウィンドウ非アクティブ化でも終了させる
    scrollBall.addEventListener("lostpointercapture", EndBallDrag);
    window.addEventListener("blur", EndBallDrag);
  }

  // ライバルペアステッカースライダー（7枚。矢印＋クリック可能ページネーション＋自動再生）
  var pairBlock = document.querySelector(".sticker-pair");
  if (pairBlock) {
    new Swiper(pairBlock.querySelector(".swiper"), {
      loop: true,
      speed: 500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false // 矢印・ページネーション操作後も自動再生を続ける
      },
      navigation: {
        prevEl: ".sticker-pair--prev",
        nextEl: ".sticker-pair--next"
      },
      pagination: {
        el: ".sticker-pair--pagination",
        clickable: true
      }
    });
  }

  // ANIMATION Control（.wait=即時表示 / .waiting=スクロール連動表示。共に .animation / .animating へ遷移）
  var AnimationStart = function ($container) {
    var _$wait = $container.find(".wait");
    _$wait.each(function () {
      var __$this = $(this);
      var __delay = __$this.data("delay") || 0;
      var __timeout = setTimeout(function () {
        __$this.removeClass("wait").addClass("animation");
        clearTimeout(__timeout);
      }, __delay);
    });
  };

  var isEventSetAnimation = true;

  // .waiting中は transform: scale(.5)（中心基準）で縮んでいるため、offset().top
  // （getBoundingClientRectベース）だと縦長要素ほど上端が下がって見え発火が遅れる。
  // transformの影響を受けないレイアウト座標（offsetTopの累積）で判定する
  var GetLayoutTop = function (el) {
    var top = 0;
    while (el) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    return top;
  };

  var SetAnimation = function () {
    var $section = $(".waiting");
    var sectionLen = $section.length;
    var timing = windowInnerHeight - (windowInnerHeight / 5);

    if (sectionLen === 0) {
      isEventSetAnimation = false;
    } else {
      for (var i = 0; i < sectionLen; i++) {
        var $wait = $($section[i]);
        var offsetTop = GetLayoutTop($section[i]);

        if ($window.scrollTop() + timing >= offsetTop && $window.scrollTop() <= offsetTop) {
          var _delay = $wait.data("delay");
          if (_delay === void 0) _delay = 0;
          $wait.delay(_delay).queue(function () {
            var __$this = $(this);
            __$this.removeClass("waiting").addClass("animating");
            __$this.dequeue();
          });
        }
      }
    }
  };

  var AnimationScroller = function () {
    if (isEventSetAnimation) SetAnimation();
  };

  // LOADED（ローディングのフェードアウト .5s を待ってから初期アニメーションを開始）
  // onloadが早い場合もローディング画面を最低2秒は見せる：
  // performance.now()＝ナビゲーション開始からの経過ms。2秒に満たない残り時間だけ遅らせて loaded にする
  var MIN_LOADING_MS = 2000;
  var loadedTimer = setTimeout(function () {
    $body.addClass("loaded");

    var startTimer = setTimeout(function () {
      AnimationStart($("#mv"));
      SetAnimation(); // 初期表示範囲内の .waiting はスクロールを待たずに発火させる
      $window.on("scroll", AnimationScroller);
      clearTimeout(startTimer);
    }, 600);
    clearTimeout(loadedTimer);
  }, Math.max(0, MIN_LOADING_MS - performance.now()));
};

window.addEventListener("load", Init);
